
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ExpertCompanyEmployees extends Vue {}
